import Vue from "vue";
import Vuex from "vuex";
import Progress from "../logic/common/progress";
import Constant from "./constant";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const waitingStatusToBoolean = (waiting) => {
  return waiting > 0 ? true : false;
};

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    // トークン
    token: localStorage.getItem("token") || "",
    // トークン有効期限
    tokenExpiration: localStorage.getItem("tokenExpiration") || "",
    // リフレッシュトークン
    refreshToken: localStorage.getItem("refreshToken") || "",
    // しばらくお待ちくださいの表示状態
    waiting: 0,
    // ログイン中のユーザーの情報
    user: {
      // 表示名
      displayName: "",
      // 所属グループIDの配列
      groupIds: [],
      // 所属グループパーミッションの配列
      userJoinPermissions: [],
      // ユーザーID
      userId: "",
      // システム管理者フラグ
      flagSystemAdmin: false,
      // 承認したtosのバージョン
      tosVersion: "",
      // 新着広島県お知らせの有無
      prefInformationNotice: false,
      // 新着お知らせの有無
      informationNotice: false,
      // お知らせ編集権限
      informationEditable: false,
      // CSV出力権限フラグ
      csvPermission: false,
      // 生産者フラグ
      flagProducer: false,
      // 採取海域区分
      seaArea: 0,
      // 観測地点
      deviceId: "3362,3362,3362",
      // 観測地点
      locationId: "0,0,0",
    },
    // HACCPユーザー一覧
    haccpUserList: [],
    // ユーザー一覧
    manageUserList: [],
    // グループ一覧
    manageGroupList: [],
    // 広島県のお知らせ一覧
    managePrefInformationList: [],
    // 広島県の分類一覧
    managePrefCategoryList: [],
    // 広島県のメール通知設定￥＝一覧
    managePrefCategoryMailSettingList: [],
    // お知らせ一覧
    manageInformationList: [],
    // 分類一覧
    manageCategoryList: [],
    // メール通知設定￥＝一覧
    manageCategoryMailSettingList: [],
    // 利用状況一覧
    manageUsageList: [],
    // アンケート一覧
    manageQuestionList: [],
  },
  getters: {
    /**
     * 認証トークンを返す
     */
    token(state) {
      return state.token;
    },
    /**
     * 認証トークンの有効期限を返す
     */
    tokenExpiration(state) {
      return state.tokenExpiration;
    },
    /**
     * リフレッシュトークンを返す
     */
    refreshToken(state) {
      return state.refreshToken;
    },
    /**
     * 利用規約に承認済みであればtrueを返す
     */
    isTosAgree(state) {
      if (state.user.tosVersion == Constant.TOS_VERSION) {
        return true;
      }
      return false;
    },
    /**
     * 利用規約の最新バージョンを返す
     */
    latestTosVersion() {
      return Constant.TOS_VERSION;
    },
    /**
     * しばらくお待ちくださいが表示中であればtrueを返す
     */
    isWaiting(state) {
      return waitingStatusToBoolean(state.waiting);
    },
    /**
     * ログイン中のアカウントの表示名を返す
     */
    userDisplayName(state) {
      return state.user.displayName;
    },
    /**
     * Haccp閲覧可能なユーザーの一覧を返す
     */
    haccpUserList(state) {
      return state.haccpUserList;
    },
    /**
     * ユーザー一覧を返す
     */
    manageUserList(state) {
      return state.manageUserList;
    },
    /**
     * グループ一覧を返す
     */
    manageGroupList(state) {
      return state.manageGroupList;
    },
    /**
     * 広島県のお知らせ一覧を返す
     */
    managePrefInformationList(state) {
      return state.managePrefInformationList;
    },
    /**
     * 広島県の分類一覧を返す
     */
    managePrefCategoryList(state) {
      return state.managePrefCategoryList;
    },
    /**
     * 広島県のメール通知設定一覧を返す
     */
    managePrefCategoryMailSettingList(state) {
      return state.managePrefCategoryMailSettingList;
    },
    /**
     * お知らせ一覧を返す
     */
    manageInformationList(state) {
      return state.manageInformationList;
    },
    /**
     * 分類一覧を返す
     */
    manageCategoryList(state) {
      return state.manageCategoryList;
    },
    /**
     * メール通知設定一覧を返す
     */
    manageCategoryMailSettingList(state) {
      return state.manageCategoryMailSettingList;
    },
    /**
     * 利用状況一覧を返す
     */
    manageUsageList(state) {
      return state.manageUsageList;
    },
    /**
     * アンケート一覧を返す
     */
    manageQuestionList(state) {
      return state.manageQuestionList;
    },
    /**
     * システム管理者であればtrueを返す
     */
    isSystemAdmin(state) {
      return state.user.flagSystemAdmin;
    },
    /**
     * 所属グループIDの配列
     */
    userGroupIds(state) {
      return state.user.groupIds;
    },
    /**
     * 所属グループパーミッションの配列
     */
    userJoinPermissions(state) {
      return state.user.userJoinPermissions;
    },
    /**
     * ログインユーザーID
     */
    userId(state) {
      return state.user.userId;
    },
    categoryList(state) {
      return state.categoryList;
    },
    /**
     * 新着の広島県お知らせの有無
     */
    prefInformationNotice(state) {
      return state.user.prefInformationNotice;
    },
    /**
     * 新着のお知らせの有無
     */
    informationNotice(state) {
      return state.user.informationNotice;
    },
    /**
     * お知らせ編集権限
     */
    informationEditable(state) {
      return state.user.informationEditable;
    },
    /**
     * CSV出力権限フラグ
     */
    csvPermission(state) {
      return state.user.csvPermission;
    },
    /**
     * 生産者フラグ
     */
    flagProducer(state) {
      return state.user.flagProducer;
    },
    /**
     * 採取海域区分
     */
    seaArea(state) {
      return state.user.seaArea;
    },
    /**
     * 観測地点
     */
    deviceId(state) {
      return state.user.deviceId;
    },
    /**
     * 観測地点ロケーション
     */
    locationId(state) {
      return state.user.locationId;
    },    
  },
  mutations: {
    /**
     * 認証トークンを更新する
     * @param {JWTトークン} token
     */
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token);

      if (token) {
          let date = new Date();
          let expiration = date.getTime() + 30 * 60 * 1000; // 30分後を期限として設定
          state.tokenExpiration = expiration;
          localStorage.setItem("tokenExpiration", expiration);
      } else {
          state.tokenExpiration = "";
          localStorage.setItem("tokenExpiration", "");
      }

    },
    /**
     * リフレッシュトークンを更新する
     * @param {JWTトークン} token
     */
    setRefreshToken(state, token) {
        state.refreshToken = token;
        localStorage.setItem("refreshToken", token);
    },
    /**
     * Waitingカウンタ初期化
     */
    waitingInit(state) {
      state.waiting = 0;
    },
    /**
     * 利用規約を承認する
     */
    tosAgreed(state, version) {
      state.user.tosVersion = version;
    },
    /**
     * しばらくお待ちくださいの表示状態を変更する
     * @param {true：表示する、false：表示しない} value
     */
    setWaiting(state, value) {
      // 現在の表示状態を取得する
      const current = waitingStatusToBoolean(state.waiting);
      // 表示要求なら増やす、非表示要求なら減らす
      if (value) {
        state.waiting = state.waiting + 1;
      } else {
        state.waiting = state.waiting - 1;
      }
      // 変更後の表示状態を取得する
      const newState = waitingStatusToBoolean(state.waiting);
      if (current != newState) {
        if (newState == true) {
          Progress.show();
        } else {
          Progress.hide();
        }
      }
    },
    /**
     * ログイン中のアカウントの表示名を更新する
     * @param {表示名} value
     */
    setUserDisplayName(state, value) {
      state.user.displayName = value;
    },
    /**
     * Haccp情報を閲覧可能なユーザーの一覧をキャッシュする
     * @param {Haccp情報を閲覧可能なユーザーのリスト} value
     */
    setHaccpUserList(state, value) {
      state.haccpUserList = value;
    },
    /**
     * ユーザー一覧をキャッシュする
     */
    setManageUserList(state, value) {
      state.manageUserList = value;
    },
    /**
     * グループ一覧をキャッシュする
     */
    setManageGroupList(state, value) {
      state.manageGroupList = value;
    },
    /**
     * 広島県のお知らせ一覧をキャッシュする
     */
    setManagePrefInformationList(state, value) {
      state.managePrefInformationList = value;
    },
    /**
     * 広島県の分類一覧をキャッシュする
     */
    setManagePrefCategoryList(state, value) {
      state.managePrefCategoryList = value;
    },
    /**
     * 広島県のお知らせメール通知設定一覧をキャッシュする
     */
    setManagePrefCategoryMailSettingList(state, value) {
      state.managePrefCategoryMailSettingList = value;
    },
    /**
     * お知らせ一覧をキャッシュする
     */
    setManageInformationList(state, value) {
      state.manageInformationList = value;
    },
    /**
     * 分類一覧をキャッシュする
     */
    setManageCategoryList(state, value) {
      state.manageCategoryList = value;
    },
    /**
     * お知らせメール通知設定一覧をキャッシュする
     */
    setManageCategoryMailSettingList(state, value) {
      state.manageCategoryMailSettingList = value;
    },
    /**
     * 利用状況一覧をキャッシュする
     */
    setManageUsageList(state, value) {
      state.manageUsageList = value;
    },
    /**
     * アンケート一覧をキャッシュする
     */
    setManageQuestionList(state, value) {
      state.manageQuestionList = value;
    },
    /**
     * システム管理者フラグを更新する
     */
    setFlagSystemAdmin(state, value) {
      state.user.flagSystemAdmin = value;
    },
    /**
     * ユーザーのグループIDを更新する
     */
    setUserGroupIds(state, value) {
      state.user.groupIds = value;
    },
    /**
     * 所属グループパーミッションを更新する
     */
    setUserJoinPermissions(state, value) {
      state.user.userJoinPermissions = value;
    },
    /**
     * ユーザーのユーザーIDを更新する
     */
    setUserId(state, value) {
      state.user.userId = value;
    },
    /**
     * 新着の広島県のお知らせの有無
     */
    setPrefInformationNotice(state, value) {
      state.user.prefInformationNotice = value;
    },
    /**
     * 新着のお知らせの有無
     */
    setInformationNotice(state, value) {
      state.user.informationNotice = value;
    },
    /**
     * お知らせ編集権限
     */
    setInformationEditable(state, value) {
      state.user.informationEditable = value;
    },
    /**
     * CSV出力権限フラグ
     */
    setCsvPermission(state, value) {
      state.user.csvPermission = value;
    },
    /**
     * 生産者フラグ
     */
    setFlagProducer(state, value) {
      state.user.flagProducer = value;
    },
    /**
     * 採取海域区分
     */
    setSeaArea(state, value) {
      state.user.seaArea = value;
    },
    /**
     * 観測地点
     */
    setDeviceId(state, value) {
      state.user.deviceId = value;
    },
    /**
     * 観測地点ロケーション
     */
    setLocationId(state, value) {
      state.user.locationId = value;
    },
  },
});

export default store;
